import styles from "./reset.module.css";
import clsx from "clsx";

const reset = styles.reset;

const componentDefaults = styles.componentDefaults;

export const prepareBaseColors = ({
  primaryColor = "",
  primaryColorContrast = "",
  secondaryColor = "",
  secondaryColorContrast = "",
} = {}) => {
  if (
    !primaryColor &&
    !secondaryColor &&
    !primaryColorContrast &&
    !secondaryColorContrast
  )
    return "";

  return `
    /* Websail Theming Variables */
    .${reset} {
      --ws-primary-color: ${primaryColor || "#0000ee"};
      --ws-secondary-color: ${secondaryColor || "color-mix(in srgb, var(--ws-primary-color), #000 10%)"};
  
      --ws-primary-color-contrast: ${primaryColorContrast || "#fff"};
      --ws-secondary-color-contrast: ${secondaryColorContrast || "#fff"};
    }
    `;
};

export const prepareAdditionalCss = (additionalCss = "") => {
  if (!additionalCss) return "";
  return `/* Websail Custom Styles */\n${additionalCss}`;
};

export const themeReset = clsx(reset, componentDefaults);
